{
  "Dashboard": "Dashboard",
  "BlyCareShippingProte": "BlyCare Versandschutz",
  "LoadingBlyCare": "BlyCare wird geladen…",
  "LoadingWidgetSetting": "Widget-Einstellungen werden geladen…",
  "PreparingYourWorkspa": "Arbeitsbereich wird vorbereitet",
  "Language": "Sprache",
  "English": "English",
  "EnglishDefault": "English (Default)",
  "German": "Deutsch",
  "Spanish": "Español",
  "French": "Français",
  "Italian": "Italiano",
  "Japanese": "日本語",
  "Korean": "한국어",
  "Dutch": "Nederlands",
  "Polish": "Polski",
  "Portuguese": "Português",
  "Ukrainian": "Українська",
  "SimplifiedChinese": "简体中文",
  "TraditionalChinese": "繁體中文",
  "SetupGuide": "Einrichtungsleitfaden",
  "CompletedOfTotalComp": "{{completed}} von {{total}} abgeschlossen",
  "Dismiss": "Verwerfen",
  "MoreActions": "Weitere Aktionen",
  "ToggleSetupGuide": "Einrichtungsleitfaden umschalten",
  "ActivateAppEmbed": "App-Einbettung aktivieren",
  "ClickTheEnableButton": "1. Klicken Sie unten auf die Schaltfläche Aktivieren, um den Shopify-Theme-Editor zu öffnen.",
  "BlyCareEmbedSection": "2. Suchen Sie links im Abschnitt App-Einbettung nach BlyCare. Stellen Sie sicher, dass der Schalter aktiviert ist. Klicken Sie dann oben rechts auf Speichern.",
  "Enable": "Aktivieren",
  "PublishWidget": "Widget veröffentlichen",
  "PublishStorefront": "Veröffentlichen Sie das Widget in Ihrem Storefront, damit Kunden es kaufen können.",
  "Publish": "Veröffentlichen",
  "SetProtectionFee": "Schutzgebühr festlegen",
  "FeeYouWantToCharge": "Legen Sie die Gebühr fest, die Sie Kunden berechnen möchten.",
  "Setup": "Einrichten",
  "TestYourWidgetOnYour": "Testen Sie Ihr Widget in Ihrem Shop",
  "AddAProductToYourCar": "Fügen Sie ein Produkt zum Warenkorb hinzu und prüfen Sie, ob das Versandschutz-Widget angezeigt wird. Wählen Sie den Versandschutz aus, fahren Sie dann mit der Kasse fort und stellen Sie sicher, dass das Versandschutzprodukt auf der Kassenseite enthalten ist.",
  "TestNow": "Jetzt testen",
  "Working": "Alles funktioniert",
  "NeedHelp": "Hilfe benötigt",
  "MarkAsCompleted": "Als abgeschlossen markieren",
  "AppStatus": "App-Status",
  "AppEmbed": "App-Einbettung",
  "EnableAppEmbedToDisp": "Aktivieren Sie die App-Einbettung, um den Versandschutz im Warenkorb anzuzeigen.",
  "CartPage": "Versandschutz auf der Warenkorbseite anzeigen.",
  "CheckoutBlock": "Kassenblock",
  "CheckoutPage": "Versandschutz auf der Kassenseite anzeigen.",
  "Active": "Aktiv",
  "Inactive": "Inaktiv",
  "Analytics": "Analysen",
  "Today": "Heute",
  "Last7Days": "Letzte 7 Tage",
  "Last30Days": "Letzte 30 Tage",
  "Last60Days": "Letzte 60 Tage",
  "Last90Days": "Letzte 90 Tage",
  "Last365Days": "Letzte 365 Tage",
  "Custom": "Benutzerdefiniert",
  "Start": "Start",
  "End": "Ende",
  "DateRange": "Zeitraum",
  "SelectedRange": "Ausgewählter Zeitraum: {{range}}",
  "Cancel": "Abbrechen",
  "Save": "Speichern",
  "ChooseAStartDateOnOr": "Wählen Sie ein Startdatum, das am oder vor dem Enddatum liegt, und wählen Sie keinen Tag nach heute.",
  "PreviousMonth": "Vorheriger Monat",
  "NextMonth": "Nächster Monat",
  "ProtectionRevenue": "Schutzumsatz",
  "ProtectedOrders": "Geschützte Bestellungen",
  "ProtectedOrderRate": "Anteil geschützter Bestellungen",
  "LoadingAnalytics": "Analysen werden geladen…",
  "AnalyticsCouldNotLo": "Analysen konnten nicht geladen werden",
  "RetryAnalytics": "Analysen erneut versuchen",
  "Resources": "Ressourcen",
  "HowDoesShippingProte": "Wie funktioniert der Versandschutz?",
  "BlyCareAddsAShipping": "BlyCare fügt Ihrem Warenkorb ein Versandschutz-Widget hinzu. Kunden können den Schutz für ihre Bestellungen hinzufügen. Der Händler, der die Schutzgebühr erhebt, entscheidet, welche Fälle abgedeckt sind, und verwendet diese Gebühren zur Bearbeitung von Ansprüchen.",
  "DoesBlyCareCoverInsu": "Deckt BlyCare Versicherungsansprüche ab?",
  "NoBlyCareIsNotInsura": "Nein. BlyCare ist keine Versicherung und zahlt keine Ansprüche aus. BlyCare stellt nur das Widget und die Tools bereit, mit denen Händler ihr eigenes Versandschutzprogramm verwalten.",
  "EmailUs": "E-Mail senden",
  "LiveChat": "Live-Chat",
  "HelpCenter": "Hilfe-Center",
  "Settings": "Einstellungen",
  "CheckoutWidget": "Kassen-Widget",
  "CartWidget": "Warenkorb-Widget",
  "PriceSetting": "Preiseinstellung",
  "ProductSetting": "Produkteinstellung",
  "AdminLanguage": "Admin-Sprache",
  "AdminLanguageTitle": "Admin-Sprache",
  "AdminLanguageHelp": "Ändert die App-Sprache nur für Sie. Kunden sind nicht betroffen.",
  "AppLanguage": "App-Sprache",
  "UnableToLoadSettings": "Einstellungen konnten nicht geladen werden",
  "TryAgain": "Erneut versuchen",
  "Discard": "Verwerfen",
  "LoadingSettings": "Einstellungen werden geladen",
  "PageNotFound": "Seite nicht gefunden",
  "ProductSettingsCould": "Produkteinstellungen konnten nicht gespeichert werden.",
  "Fulfillment": "Lieferabwicklung",
  "FulfillmentHelp": "Wählen Sie, wann das Schutzprodukt als abgewickelt markiert wird.",
  "ManuallyFulfill": "Manuell abwickeln",
  "MarkFulfilledWhenFir": "Als abgewickelt markieren, wenn der erste Artikel der Bestellung abgewickelt ist",
  "MarkFulfilledWhenAll": "Als abgewickelt markieren, wenn alle anderen Artikel der Bestellung abgewickelt sind",
  "MarkFulfilledImmedi": "Als abgewickelt markieren, direkt nachdem die Bestellung erstellt wurde",
  "Exclusions": "Ausschlüsse",
  "ExclusionsHelp": "Wählen Sie, wann der Schutz nicht gelten soll.",
  "ExclusionType": "Ausschlusstyp",
  "Select": "Auswählen",
  "SelectedExclusions": "Ausgewählte Ausschlüsse",
  "RemoveName": "{{name}} entfernen",
  "WhenExcluded": "Bei Ausschluss",
  "HideWidget": "Widget ausblenden",
  "KeepWidgetButSkipThe": "Widget beibehalten, aber Gebühr überspringen",
  "ExcludeProductType": "Produkttyp ausschließen",
  "SearchProductType": "Produkttyp suchen",
  "ExcludeSKU": "SKU ausschließen",
  "SearchSKU": "SKU suchen",
  "ExcludeCollection": "Kollektion ausschließen",
  "SearchCollection": "Kollektion suchen",
  "ExcludeMarket": "Markt ausschließen",
  "SearchMarket": "Markt suchen",
  "ExcludeLanguage": "Sprache ausschließen",
  "SearchLanguage": "Sprache suchen",
  "Add": "Hinzufügen",
  "PriceSettingsCouldNo": "Preiseinstellungen konnten nicht gespeichert werden.",
  "ShippingProtectionPr": "Preis für Versandschutz",
  "SetHowMuchPriceDoYou": "Legen Sie fest, welchen Preis Sie Ihrem Kunden berechnen",
  "PricingMethod": "Preismethode",
  "Fixed": "Fest",
  "Percentage": "Prozentsatz",
  "UniversalProtectionP": "Universeller Schutzpreis",
  "PercentageOfCartSubt": "Prozentsatz der Warenkorb-Zwischensumme",
  "EditCappedPrice": "Höchstpreis bearbeiten",
  "ShippingProtectionFe": "Die Versandschutzgebühr ist ein Prozentsatz ab {{minPrice}} USD, steigt um {{increment}} USD und ist auf {{capped}} USD begrenzt.",
  "MinProtectionFee": "Mindestschutzgebühr",
  "IncrementAmount": "Erhöhungsbetrag",
  "CappedProtectionFee": "Höchstschutzgebühr",
  "AddTierPrice": "Staffelpreis hinzufügen",
  "AddTier": "Staffel hinzufügen",
  "TierPriceHelp": "Wenn der Warenkorbpreis keinem Ihrer Staffelpreisbereiche entspricht, gilt der auf der vorherigen Seite festgelegte universelle Preis.",
  "MinCartPrice": "Mindest-Warenkorbpreis",
  "MaxCartPrice": "Höchst-Warenkorbpreis",
  "ProtectionFee": "Schutzgebühr",
  "RemoveTier": "Staffel entfernen",
  "Required": "Erforderlich",
  "ThisFieldIsRequired": "Dieses Feld ist erforderlich.",
  "MustBeGreaterThanZero": "{{label}} muss größer als 0 sein.",
  "MustBeOrLess": "{{label}} muss {{max}} oder kleiner sein.",
  "AtMostTwoDecimals": "{{label}} darf höchstens 2 Dezimalstellen haben.",
  "MustBeLargerThanMinC": "Muss größer als der Mindest-Warenkorbpreis sein",
  "MustBeLargerThanMaxC": "Muss größer als der Höchst-Warenkorbpreis sein",
  "MustBeSmallerThanMin": "Muss kleiner als der Mindest-Warenkorbpreis sein",
  "Price": "Preis",
  "MinimumPrice": "Mindestpreis",
  "Increment": "Erhöhung",
  "CartPageWidget": "Warenkorbseiten-Widget",
  "CheckoutPageWidget": "Kassenseiten-Widget",
  "WidgetFormat": "Widget-Format",
  "TickerWidget": "Standard-Widget",
  "CheckoutButtonWidget": "Kassenbutton-Widget",
  "Text": "Text",
  "MainText": "Haupttext",
  "Title": "Titel",
  "Description": "Beschreibung",
  "MainButtonText": "Text der Hauptschaltfläche",
  "SecondaryButtonText": "Text der sekundären Schaltfläche",
  "EnabledDescription": "Beschreibung bei Aktivierung",
  "DisabledDescription": "Beschreibung bei Deaktivierung",
  "PleaseEnterTitle": "Bitte geben Sie einen Titel ein",
  "PleaseEnterDescript": "Bitte geben Sie eine Beschreibung ein",
  "PleaseEnterMainButt": "Bitte geben Sie den Text der Hauptschaltfläche ein",
  "PleaseEnterSecondar": "Bitte geben Sie den Text der sekundären Schaltfläche ein",
  "PleaseEnterEnabledD": "Bitte geben Sie die Beschreibung bei Aktivierung ein",
  "PleaseEnterDisabled": "Bitte geben Sie die Beschreibung bei Deaktivierung ein",
  "EGViewTerms": "z. B. Bedingungen anzeigen",
  "EGHttpTerms": "z. B. https://terms.com",
  "Footer": "Fußzeile",
  "FooterText": "Fußzeilentext",
  "FooterLink": "Fußzeilenlink",
  "TooltipLink": "Tooltip-Link",
  "FooterVisibility": "Sichtbarkeit der Fußzeile",
  "TitleInfoVisibility": "Sichtbarkeit der Titelinformationen",
  "Disabled": "Deaktiviert",
  "Enabled": "Aktiviert",
  "Color": "Farbe",
  "ColorStyle": "Farbstil",
  "SizeAndDisplay": "Größe und Anzeige",
  "IconSize": "Symbolgröße",
  "IconRadius": "Symbolradius",
  "BorderSize": "Rahmengröße",
  "BorderRadius": "Rahmenradius",
  "HorizontalPadding": "Horizontaler Innenabstand",
  "VerticalPadding": "Vertikaler Innenabstand",
  "ToggleFormat": "Umschaltformat",
  "Switch": "Schalter",
  "Checkbox": "Kontrollkästchen",
  "Border": "Rahmen",
  "Background": "Hintergrund",
  "ProtectionDescript": "Schutzbeschreibung",
  "MainButtonBackgrou": "Hintergrund der Hauptschaltfläche",
  "EnabledToggle": "Aktivierter Schalter",
  "DisabledToggle": "Deaktivierter Schalter",
  "Automatic": "Automatisch",
  "Neutral": "Neutral",
  "Info": "Info",
  "Success": "Erfolg",
  "Warning": "Warnung",
  "Critical": "Kritisch",
  "Subdued": "Gedämpft",
  "Transparent": "Transparent",
  "ThemeColor": "Themenfarbe",
  "ResetToDefaultColor": "{{label}}: auf Standardfarbe zurücksetzen",
  "OpenColorPicker": "{{label}}: Farbwähler öffnen",
  "Icon": "Symbol",
  "PackageIcon": "Paketsymbol",
  "PackageIconNumber": "Paketsymbol {{value}}",
  "UploadIcon": "Symbol hochladen",
  "NoIcon": "Kein Symbol",
  "AcceptedFormats": "Akzeptierte Formate: PNG, JPG, SVG",
  "MaximumFileSize": "Maximale Dateigröße: 50 MB",
  "AddFiles": "Dateien hinzufügen",
  "RemoveImage": "Bild entfernen",
  "Uploading": "Wird hochgeladen",
  "UploadFailedTryAgain": "Upload fehlgeschlagen. Versuchen Sie es erneut.",
  "ChooseAJPEGPNG": "Wählen Sie ein JPEG-, PNG- oder SVG-Bild mit bis zu 50 MB.",
  "ChooseNonemptyImage": "Wählen Sie ein nicht leeres JPEG-, JPG-, PNG- oder SVG-Bild mit bis zu 50 MB.",
  "ImageCouldNotBeRead": "Das Bild konnte nicht gelesen werden.",
  "FileContentsMismatch": "Der Dateiinhalt muss dem Bildtyp JPEG, PNG oder SVG entsprechen.",
  "ImageCouldNotBeDecode": "Das Bild konnte nicht dekodiert werden.",
  "InvalidImageUrl": "Der Upload-Dienst hat eine ungültige Bild-URL zurückgegeben.",
  "MissingPublicImageUrl": "Der Upload-Dienst hat keine öffentliche Bild-URL zurückgegeben.",
  "CustomCssTooLong": "Benutzerdefiniertes CSS darf höchstens 2.000 Zeichen lang sein.",
  "ChooseValidIconUrl": "Wählen Sie ein hochgeladenes Symbol mit einer gültigen URL.",
  "EnterNumberRange": "Geben Sie eine Zahl von {{min}} bis {{max}} ein.",
  "EnterLocaleTextRange": "Geben Sie {{locale}}-Text mit 1 bis {{limit}} Zeichen ein.",
  "EnterValidLearnMoreUrl": "Geben Sie eine gültige URL für Weitere Informationen ein, die mit https:// oder http:// beginnt.",
  "ReviewHighlightedFields": "Überprüfen Sie die hervorgehobenen Felder.",
  "CannotChangePublishState": "Der Veröffentlichungsstatus kann erst geändert werden, wenn das Formular gültig ist: {{reason}}",
  "BlyCareCouldNotSave": "BlyCare konnte nicht speichern.",
  "CheckoutRequiresPlus": "Die Kassenanpassung erfordert Shopify Plus.",
  "SaveSucceededReloadFailed": "Die Speicheranfrage war erfolgreich, aber die neuesten Widget-Einstellungen konnten nicht geladen werden. Aktualisieren Sie die Seite, um Ihre Änderungen zu überprüfen.",
  "BlyCareCouldNotComplete": "BlyCare konnte diese Anfrage nicht abschließen.",
  "ShopifyAuthorizationRequired": "Shopify-Autorisierung ist erforderlich.",
  "AppBridgeUnavailable": "Shopify App Bridge ist nicht verfügbar",
  "ExtensionStatusUnavailable": "Der Status der Shopify-Erweiterung ist nicht verfügbar.",
  "ConfigurationPreview": "Konfigurationsvorschau",
  "On": "Ein",
  "Off": "Aus",
  "Unpublish": "Veröffentlichung aufheben",
  "AppEmbedIsNotEnable": "Die App-Einbettung ist nicht aktiviert.",
  "GoEnabled": "Zur Aktivierung",
  "ViewOnYourStorefront": "In Ihrem Storefront anzeigen",
  "PreviewProtection": "Schutzvorschau",
  "MoreInformation": "Weitere Informationen",
  "Cart": "Warenkorb",
  "Subtotal": "Zwischensumme",
  "Checkout": "Kasse",
  "DiscountCode": "Rabattcode",
  "Apply": "Anwenden",
  "Shipping": "Versand",
  "Total": "Gesamt",
  "ShippingProtection": "Versandschutz",
  "Product": "Produkt",
  "CopyLink": "Link kopieren"
}
